export const reOrderLocale = $localize`:AnalyticsDashboard|Analytics Dashboard re-order filter text@@analyticsDashboardReOrderFilterText:Re-Order`;
export const preOrderLocale = $localize`:AnalyticsDashboard|Analytics Dashboard pre-order filter text@@analyticsDashboardPreOrderFilterText:Pre-Order`;

export const defaultFilterText = {
  brandOrgs: $localize`:AnalyticsDashboard|Best Performing Lists Selected
                Title@@bestPerformingListsSelectedTitle:Global`,
  orderTypes: $localize`:AnalyticsDashboard|Best Performing Articles Selected
                Title Order Type@@bestPerformingArticlesSelectedOrderTypeTitle:Order type`,
  categories: $localize`:AnalyticsDashboard|Best Performing Articles Selected
                Title Category@@bestPerformingArticlesSelectedCategoryTitle:Category`,
};

export const headerText = {
  article: $localize`:Dashboard|Dashboard Best Performing Article Header
                Article@@productListBestPerformingArticlesHeaderArticle:Article`,
  itemBought: $localize`:Dashboard|Dashboard Best Performing Article Header Total
                Bought@@productListBestPerformingArticlesHeaderTotalBought:Items bought`,
  revenue: $localize`:Dashboard|Dashboard Best Performing Article Header
                Revenue@@productListBestPerformingArticlesHeaderRevenue: Revenue`,
  popularity: $localize`:Dashboard|Dashboard Best Performing Article Header
                Popularity@@productListBestPerformingArticlesHeaderPopularity: Popularity`,
  category: $localize`:Dashboard|Dashboard Best Performing Lists Header
                Category@@productListBestPerformingListsHeaderCategory: Category`,
};

export const headerTooltipText = {
  popularity: $localize`:AnalyticsDashboard|Dashboard Best performing article tooltip text for popularity@@productListBestPerformingArticlesHeaderTooltipPopularity:How many individual customers have bought this article`,
};

export const bestPerformingArticlesShowAllText = $localize`:AnalyticsDashboard|Best Performing Articles Show all Text@@bestPerformingArticlesShowAllOption:Show all`;
